import { render, staticRenderFns } from "./proDetail.vue?vue&type=template&id=ff040404&scoped=true&"
import script from "./proDetail.vue?vue&type=script&lang=js&"
export * from "./proDetail.vue?vue&type=script&lang=js&"
import style0 from "./proDetail.vue?vue&type=style&index=0&id=ff040404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff040404",
  null
  
)

export default component.exports